import { useEffect, useState } from "react";
import EmailInvite from "../../assets/svg/EmailInvite";
import DeleteIcon from "../../assets/svg/DeleteIcon";
import dayjs from "@lib/dayjs";

import { useSelector } from "react-redux";
import { isNullOrEmpty } from "../../utils/helperFunction";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";
import CheckMark from "../../assets/svg/CheckMark";
import CrossMark from "../../assets/svg/CrossMark";
import { useNavigate } from "react-router-dom";
import PlusIcon from "../../assets/svg/PlusIcon";
import { useForm } from "react-hook-form";
import userImg from "../../assets/images/emptyUser.png";
import CustomInput from "../../components/CustomInput/CustomInput";
import CrossBig from "../../assets/svg/CrossBig";
import { useSnackbar } from "notistack";
import { inviteUserViaEmail } from "../../endpoints/recruiter.service";
import { colors } from "@nextui-org/theme";
import CancelInviteIcon from "../../assets/svg/CancelInviteIcon";
import {
  addNewReferral,
  deleteReferral,
  getReferralRequests,
} from "../../endpoints/candidate.service";
import { referralRequestActionApi } from "../../endpoints/referral.service";

const HomePage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [selectedReferralId, setSelectedReferralId] = useState(null);
  const [isCancelInviteModal, setIsCancelInviteModal] = useState(false);
  const [referralRequestData, setReferralRequestData] = useState();
  const [isInviteModal, setIsInviteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(undefined);
  const [activeTab, setActiveTab] = useState("invites");
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      inviteModal: false,
      isSubmitting: false,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
    },
  });
  const fields = watch();

  useEffect(() => {
    getAllReferralRequests();
  }, []);

  const handleCloseInviteModal = () => {
    setIsCancelInviteModal(false);
  };
  const handleColseInviteModal = () => {
    setIsInviteModal(false);
  };

  const notificationRequestAction = async ({ requestId, action }) => {
    setIsLoading({ _id: requestId, action });
    try {
      const data = await referralRequestActionApi({ requestId, action });
      await getAllReferralRequests();
    } catch (e) {
      console.error("Action failed:", e);
    } finally {
      setIsLoading(undefined);
    }
  };

  const getAllReferralRequests = async () => {
    try {
      const { data } = await getReferralRequests();
      setReferralRequestData(data);
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const deleteReferralInvite = async (_id) => {
    try {
      setIsLoading(true);
      const { success, data } = await deleteReferral(_id);
      if (success) {
        await getAllReferralRequests();
        enqueueSnackbar("Referral deleted successfully!", {
          variant: "success",
        });
      }
      setIsCancelInviteModal(false);
      setSelectedReferralId(null);
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const resendNewReferral = async (params) => {
    try {
      const { success } = await addNewReferral(params);
      if (success) {
        enqueueSnackbar("Invited sucessfully.", {
          variant: "success",
        });
        setIsInviteModal(true);
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
    }
  };

  const handleFormSubmit = async () => {
    setValue("isSubmitting", true);
    try {
      await inviteUserViaEmail({
        firstName: fields?.firstName,
        lastName: fields?.lastName,
        email: fields?.email,
      });
      getAllReferralRequests();
      enqueueSnackbar("Member invited successfully", { variant: "success" });
      reset({
        inviteModal: false,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
      });
    } catch (error) {
      enqueueSnackbar("Error inviting member", { variant: "error" });
    } finally {
      setValue("isSubmitting", false);
    }
  };

  return (
    <div className="flex h-full w-full bg-white rounded-lg overflow-hidden p-6 gap-5">
      {loading ? (
        <div className="flex flex-1 flex-col items-center justify-center">
          <LoadingAnimation color={"black"} />
        </div>
      ) : (
        <>
          <div className="w-1/3 h-[633px] bg-white border border-[#ECECEC] rounded-sm p-6 flex flex-col items-center gap-4">
            <p className="text-xs text-charcoal font-semibold mb-5">
              Referral member account
            </p>
            <p className="font-medium text-xs">{user?.refNo}</p>

            <div className="flex rounded-full h-[150px] w-[150px] bg-[#E1E0E0] items-center justify-center max-md:h-36 max-md:w-36">
              {user?.profilePic ? (
                <img
                  src={user?.profilePic}
                  className="h-full w-full object-cover rounded-full"
                  alt="profileImg"
                />
              ) : (
                <span className="font-montserrat text-white font-semibold text-6xl">
                  {user?.firstName?.charAt(0).toUpperCase()}
                  {user?.lastName?.charAt(0).toUpperCase()}
                </span>
              )}
            </div>
            <div className="text-center">
              <p className="font-medium text-sm mb-3">
                {user?.firstName} {user?.lastName}
              </p>
              <p className="text-xs text-gray-500 mb-3 lowercase">
                <span className="font-semibold text-xs text-charcoal pe-3">
                  Username :
                </span>{" "}
                <span className="lowercase">{user?.userName}</span>
              </p>
              <a
                href="#"
                className="text-xs text-charcoal break-all mb-3 lowercase"
              >
                {`https://comtracked/profile/${user?.userName}`}
              </a>
            </div>
            <button
              className=" bg-[#f7f7f7] px-12  py-2 font-semibold  text-xs  mt-4 border border-[#ececec] rounded-sm"
              onClick={() => {
                navigate("/account");
              }}
            >
              Edit your account
            </button>

            <p className="text-xs ont-medium text-charcoal mt-20">
              You are referral member since{" "}
              {dayjs(user?.createdAt).format("DD/MM/YY")}
            </p>
          </div>

          <div className="flex flex-col w-2/3 bg-white overflow-hidden h-full">
            <div className="flex border-b gap-10 items-center">
              <button
                className={`text-xs px-4 py-2 mb-1 ${
                  activeTab === "invites"
                    ? "font-semibold border-b-2 border-primary text-charcoal"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("invites")}
              >
                Invites
              </button>
              <button
                className={`text-xs px-4 py-2 mb-1 ${
                  activeTab === "tracker"
                    ? "font-semibold border-b-2 border-primary text-charcoal"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("tracker")}
                disabled
              >
                Tracker
              </button>

              <button
                onClick={() => setValue("inviteModal", true)}
                className="ml-auto flex items-center justify-center border bg-green-600 rounded-lg px-2 py-1 gap-1  text-white font-semibold text-sm"
              >
                <PlusIcon className="w-4 h-4" fill="white" />
                Invite
              </button>
            </div>

            {activeTab === "invites" && (
              <div className="flex-1 bg-white rounded-lg overflow-y-auto space-y-4 no-scrollbar">
                {isNullOrEmpty(referralRequestData) ? (
                  <div className="flex flex-col gap-6 items-center mt-40">
                    <p className="text-xs font-medium text-charcoal">
                      You don’t have any referral member added to your account.
                    </p>
                  </div>
                ) : (
                  <>
                    {referralRequestData.map((invite, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center justify-between py-4 border-b"
                      >
                        <div className="flex-1">
                          <p
                            className={`text-xs mb-2 font-medium ${
                              invite?.status === "approved"
                                ? "text-[#23BD33]"
                                : invite.status === "declined"
                                ? "text-[#FF3B3B]"
                                : "text-[#FF9800]"
                            }`}
                          >
                            {invite?.status === "approved"
                              ? "Accepted"
                              : invite?.status === "declined"
                              ? "Rejected"
                              : "Pending confirmation"}
                          </p>

                          <p className="text-xs mb-2 text-light-black">
                            {dayjs(invite?.createdAt).format("DD/MM/YY hh:mm")}
                          </p>
                          <p className="text-xs mb-2 text-charcoal font-semibold">
                            {invite?.external === false
                              ? "Internal"
                              : "External"}{" "}
                            invite{" "}
                            {invite.createdBy === user?._id
                              ? "sent"
                              : "received"}
                          </p>
                        </div>

                        <div className="flex flex-col items-center flex-1">
                          {invite?.external === true ? (
                            <img
                              src={userImg}
                              className="rounded-full h-16 w-16 object-cover"
                              alt="profileImg"
                            />
                          ) : invite?.candidateId?.profilePic ? (
                            <img
                              src={invite?.candidateId?.profilePic}
                              alt={invite?.candidateId?.name}
                              className="rounded-full h-16 w-16 object-cover"
                            />
                          ) : (
                            <div className="flex rounded-full h-16 w-16 bg-[#E1E0E0] items-center justify-center">
                              <span className="font-montserrat text-white font-semibold text-2xl">
                                {invite?.candidateId?.firstName
                                  ?.charAt(0)
                                  .toUpperCase()}
                                {invite?.candidateId?.lastName
                                  ?.charAt(0)
                                  .toUpperCase()}
                              </span>
                            </div>
                          )}

                          <p className="font-medium text-xs mt-2">
                            {invite?.candidateId?.refNo || "-"}
                          </p>
                        </div>

                        <div className="flex-1">
                          <p className="text-xs font-medium text-light-black mb-1">
                            {invite?.external === false ? (
                              <>
                                {invite?.candidateId?.firstName}{" "}
                                {invite?.candidateId?.lastName}
                              </>
                            ) : (
                              <>{invite?.candidateName}</>
                            )}
                          </p>
                          {invite?.candidateId?.userId?.userName && (
                            <p className="text-xs text-charcoal">
                              <span className="font-semibold text-xs pe-3">
                                Username :
                              </span>
                              {invite?.candidateId?.userId?.userName || "-"}
                            </p>
                          )}

                          <a className="text-xs text-light-black font-medium break-all">
                            {invite?.external === false ? (
                              <>{invite?.candidateId?.userId?.email}</>
                            ) : (
                              <>{invite?.candidateEmail}</>
                            )}
                          </a>

                          <a
                            href="#"
                            className="text-xs text-charcoal break-all mb-3 lowercase"
                          >
                            {invite?.candidateId?.userId?.userName
                              ? `https://comtracked/profile/${invite.candidateId.userId.userName}`
                              : "-"}
                          </a>
                          {invite?.candidateId?.username && (
                            <a className="text-xs text-light-black font-medium break-all">
                              {invite?.candidateId?.username}
                            </a>
                          )}
                        </div>

                        <div
                          className={
                            invite.status === "declined"
                              ? "invisible flex flex-1"
                              : "flex gap-2 flex-1 justify-end "
                          }
                        >
                          {invite.status === "pending" &&
                          invite.createdBy !== user?._id ? (
                            <>
                              <button
                                className={
                                  "bg-light-white-700 border border-[#ECECEC] rounded-sm p-2 min-w-4"
                                }
                                disabled={
                                  !isNullOrEmpty(isLoading) &&
                                  isLoading?._id === invite?._id
                                }
                                title="Accept Request"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  notificationRequestAction({
                                    requestId: invite?._id,
                                    action: "approved",
                                  });
                                }}
                              >
                                {!isNullOrEmpty(isLoading) &&
                                isLoading?._id === invite?._id &&
                                isLoading?.action === "approved" ? (
                                  <LoadingAnimation
                                    className="h-5 w-5 ml-0 mr-0"
                                    color={colors.black}
                                  />
                                ) : (
                                  <CheckMark width={18} height={16} />
                                )}
                              </button>
                              <button
                                className={
                                  "bg-light-white-700 border items-center justify-center border-[#ECECEC] rounded-sm p-2 min-w-4"
                                }
                                title="Reject Request"
                                disabled={
                                  !isNullOrEmpty(isLoading) &&
                                  isLoading?._id === invite?._id
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  notificationRequestAction({
                                    requestId: invite?._id,
                                    action: "declined",
                                  });
                                }}
                              >
                                {!isNullOrEmpty(isLoading) &&
                                isLoading?._id === invite?._id &&
                                isLoading?.action === "declined" ? (
                                  <LoadingAnimation
                                    className="h-5 w-5 ml-0 mr-0"
                                    color={colors.black}
                                  />
                                ) : (
                                  <CrossMark
                                    className={""}
                                    width={16}
                                    height={16}
                                    fill={"#ffffff"}
                                  />
                                )}
                              </button>
                            </>
                          ) : invite?.status !== "approved" &&
                            invite?.status !== "declined" ? (
                            <>
                              <button
                                className="bg-light-white-700 border border-[#ECECEC] rounded-sm p-2 opacity-100"
                                title="Resend"
                                onClick={() =>
                                  resendNewReferral({
                                    requestId: invite?._id,
                                  })
                                }
                              >
                                <EmailInvite
                                  width={18}
                                  height={16}
                                  fill={"#ffffff"}
                                />
                              </button>

                              <button
                                className="bg-light-white-700 border border-[#ECECEC] rounded-sm p-2 opacity-100"
                                title="Delete"
                                onClick={() => {
                                  setSelectedReferralId(invite?._id);
                                  setIsCancelInviteModal(true);
                                }}
                              >
                                <DeleteIcon width={18} height={16} />
                              </button>
                            </>
                          ) : (
                            <p className="text-xs px-2 text-gray-600">
                              {dayjs(invite.updatedAt).format(
                                "DD-MM-YYYY hh:mm A"
                              )}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          </div>
        </>
      )}

      {fields?.inviteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-xl font-semibold">Invite Contact</h2>
              <button
                onClick={() =>
                  reset({
                    inviteModal: false,
                    firstName: undefined,
                    lastName: undefined,
                    email: undefined,
                  })
                }
              >
                <CrossBig width={24} height={24} />
              </button>
            </div>
            <div className="bg-[#F9FAFB] px-8 py-3 rounded-2xl">
              <div className="mb-4">
                <CustomInput
                  label="First Name"
                  name="firstName"
                  control={control}
                  errors={errors}
                  rules={{
                    required: "This field is required.",
                  }}
                />
              </div>
              <div className="mb-4">
                <CustomInput
                  label="Last Name"
                  name="lastName"
                  control={control}
                  errors={errors}
                  rules={{
                    required: "This field is required.",
                  }}
                />
              </div>
              <div className="mb-4">
                <CustomInput
                  label="Email address"
                  name="email"
                  control={control}
                  errors={errors}
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/,
                      message: "Invalid email address",
                    },
                  }}
                />
              </div>
              <button
                onClick={handleSubmit(handleFormSubmit)}
                className="text-xl bg-primary text-white py-1.5 px-5 rounded-md flex items-center justify-self-end mt-14 mb-6"
              >
                {fields.isSubmitting && (
                  <LoadingAnimation color={colors.White} />
                )}{" "}
                Invite
              </button>
            </div>
          </div>
        </div>
      )}

      {isInviteModal && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-4 flex flex-col rounded-md max-w-[409px] mx-4">
            <button
              onClick={handleColseInviteModal}
              className="flex self-end text-black text-xl font-semibold"
            >
              X
            </button>
            <div className="flex flex-col content-center items-center gap-4">
              <p className="text-xl font-semibold text-charcoal top-8">
                Successfully sent
              </p>

              <CancelInviteIcon />

              <p className="text-sm font-medium text-charcoal text-center">
                The invitation has been successfully resend to the referral
                member - Joe Bloggs .
              </p>
            </div>
          </div>
        </div>
      )}

      {isCancelInviteModal && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 flex flex-col rounded-md max-w-[409px] mx-4 ">
            <div className="flex flex-col content-center items-center gap-4">
              <p className="text-xl font-semibold text-charcoal top-8">
                Want to cancel invite?
              </p>

              <CancelInviteIcon />

              <p className="text-sm font-medium text-charcoal text-center">
                Are you sure you want to cancel the referral member invite?
              </p>
            </div>

            <div className="flex flex-row mt-7 gap-3">
              <button
                onClick={handleCloseInviteModal}
                className="flex w-[50%] self-end gap-2 font-bold bg-white justify-center items-center text-xs text-charcoal py-2 border border-primary rounded-sm "
              >
                Not now
              </button>
              <button
                onClick={() => {
                  if (selectedReferralId) {
                    deleteReferralInvite(selectedReferralId);
                  }
                }}
                className={
                  "flex self-end gap-2 w-[50%] font-bold bg-primary justify-center items-center text-xs text-white border border-primary rounded-sm py-2 px-4 hover:bg-black"
                }
              >
                {isLoading && (
                  <LoadingAnimation
                    color={colors.White}
                    className={"w-4 h-4"}
                  />
                )}
                Yes, cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
